module.exports = __webpack_public_path__ + "static/img/glbig01.694b45c9.jpg";